// extracted by mini-css-extract-plugin
module.exports = {"contactModal":"styles_contactModal__hyD75","openingHours":"styles_openingHours__6rqak","contactInfo":"styles_contactInfo__5QyfX","faqSection":"styles_faqSection__MV2Ey"};